import { mapState } from 'vuex'
import { queryEntryCTF, downloadAssetCTF } from '@/plugins/contentful'
const fileTypes = [
  { ext: '.jpg', mime: 'image/jpeg' },
  { ext: '.png', mime: 'image/png' },
  { ext: '.pdf', mime: 'application/pdf' },
  { ext: '.doc', mime: 'application/msword' },
  { ext: '.docx', mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
  { ext: '.ppt', mime: 'application/vnd.ms-powerpoint' },
  { ext: '.pptx', mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' }
]

export const ContentType = Object.freeze({
  name: 'ButtonMixin',
  media: 'Media',
  downloadGuide: 'Download Guide'
})

/** Try to use the hidden-btn instead of this if you can. The hidden-btn component will handle
 * dialogs, if you use this mixin you will have to handle the dialogs on your own.
 */
const BtnMixin = {
  props: {
    btnId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      btnFields: null,
      internalRoute: '',
      downloadGuideModal: false
    }
  },
  computed: {
    ...mapState({ siteConfig: state => state.site.siteConfig })
  },
  async created () {
    const val = await queryEntryCTF(this.btnId)
    const { fields } = val
    this.btnFields = fields
    if (this.btnFields.internalLink) {
      const sitePage = this.siteConfig.pages.find(
        l => l.id === this.btnFields.internalLink.sys.id
      )
      if (sitePage) {
        this.internalRoute = sitePage.route
      } else {
        const page = await queryEntryCTF(this.btnFields.internalLink.sys.id)
        throw new Error(`404. ${(page && page.fields.name ? page.fields.name : 'Page')} not found`)
      }
    }
    if (this.btnFields.dropdownContent) {
      const dropdownContentFields = []
      for (let i = 0; this.btnFields.dropdownContent.length > i; i++) {
        const entryData = await queryEntryCTF(this.btnFields.dropdownContent[i].sys.id)
        if (entryData.fields.internalLink) {
          const actualLink = await queryEntryCTF(entryData.fields.internalLink.sys.id)
          entryData.fields.internalLink = actualLink.fields.name
        } else if (!entryData.fields.externalLink) {
          break
        }
        dropdownContentFields.push(entryData.fields)
      }
      this.btnFields.dropdownContent = dropdownContentFields
    }
  },
  methods: {
    btnClick () {
      if (this.$analytics && this.btnFields.googleTagEventId) {
        this.$analytics.track(this.btnFields.googleTagEventId)
      }
      if (this.btnFields.internalLink) {
        this.routeInternal()
        return
      } else if (this.btnFields.externalLink) {
        this.routeExternal()
        return
      }
      switch (this.btnFields.type) {
      case ContentType.media:
        this.downloadAsset()
        break
      case ContentType.downloadGuide:
        this.downloadGuideModal = true
        break
      default:
        throw new Error('Invalid button type')
      }
    },
    async downloadAsset () {
      const asset =
                this.btnFields.mobileMedia && window.innerWidth <= 600
                  ? await downloadAssetCTF(this.btnFields.mobileMedia.sys.id)
                  : await downloadAssetCTF(this.btnFields.media.sys.id)
      // taken from https://stackoverflow.com/questions/49474775/chrome-65-blocks-cross-origin-a-download-client-side-workaround-to-force-down
      fetch(asset.fields.file.url, {
        headers: new Headers({
          Origin: location.origin
        }),
        mode: 'cors'
      })
        .then(response => response.blob())
        .then(blob => {
          const blobUrl = window.URL.createObjectURL(blob)
          const a = document.createElement('a')

          a.href = blobUrl
          a.type = blob.type

          a.download = asset.fields.title
          var mime = fileTypes.find((value) => value.mime === a.type).ext
          if (mime !== undefined) {
            a.download = a.download + mime
          }

          // For Firefox https://stackoverflow.com/a/32226068
          document.body.appendChild(a)
          a.click()
          a.remove()
        })
        .catch(e =>
          window.open(
            this.assetToDownload.fields.file.url,
            'Download'
          )
        )
    },
    routeInternal () {
      if (!this.btnFields.internalLink) {
        return
      }
      const sitePage = this.siteConfig.pages.find(
        l => l.id === this.btnFields.internalLink.sys.id
      )
      if (sitePage) {
        if (this.$router.currentRoute.fullPath === sitePage.route) {
          if (!this.btnFields.sectionOnPage) {
            this.$scrollTo(document.getElementById('page-top'))
          } else {
            this.$scrollTo(
              document.getElementById(this.btnFields.sectionOnPage)
            )
          }
        }
        this.$router.push(sitePage.route).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err
          }
        }).then(() => {
          if (!this.btnFields.sectionOnPage) {
            return
          }
          setTimeout(() => {
            this.$scrollTo(
              document.getElementById(this.btnFields.sectionOnPage)
            )
          }, 1000)
        })
      }
    },
    routeExternal () {
      if (this.siteConfig.crossDomainUrls) {
        /* If the url is one of the Cross Domain's for google analytics (should be treated as the same site) do not show the modal,
        and route within this window instead of opening a new browser tab. Also must attach the GA cookie to the url. */
        const domains = this.siteConfig.crossDomainUrls
        if (domains.find(url => this.btnFields.externalLink.toLowerCase().includes(url.toLowerCase()) ||
        url.toLowerCase().includes(this.btnFields.externalLink.toLowerCase()))) {
          // is cross domain, attaching cookie and routing
          const tracker = window.ga.getAll()[0]
          const linker = new window.gaplugins.Linker(tracker)
          const destinationLink = linker.decorate(this.btnFields.externalLink)
          window.location.href = destinationLink
          return
        }
      }
      // Opening external link dialog if needed (confirm dialog), otherwise opening a new tab with the external link.
      const isDialog = this.btnFields.showExternalLinkModal === undefined || this.btnFields.showExternalLinkModal
      if (isDialog) {
        this.dialog = true
      } else {
        window.open(this.btnFields.externalLink, '_blank')
      }
    }
  }
}

export default BtnMixin
